import { CSSProperties } from "react"
import { withStyles, createStyles, Theme } from "@material-ui/core"

import TriplePhones from "../../../TriplePhones"

const styles = ({ breakpoints: { up } }: Theme) => {
  const xl = up("xl")

  const phoneWidthStyles: CSSProperties = {
    [xl]: {
      width: "19.3125rem",
    },
  }

  const sideStyles: CSSProperties = {
    ...phoneWidthStyles,
    top: "auto",
    transform: "none",
    position: "static",
    opacity: 1,
  }

  const marginLeft: string = "3.5rem"

  return createStyles({
    root: {
      flexShrink: 0,
      flexGrow: 0,
      [xl]: {
        marginRight: "6.8125rem",
      },
    },
    middle: {
      ...phoneWidthStyles,
      marginLeft,
    },
    left: {
      ...sideStyles,
    },
    right: {
      ...sideStyles,
      marginLeft,
    },
  })
}

export default withStyles(styles)(TriplePhones)
